import { jamezzApplicationType } from "../../../qr/App";
import { ApplicationType } from "../useSessionState";

export default function isKiosk() {
  return jamezzApplicationType.type === ApplicationType.KIOSK;
}
